import { PayloadAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { ItemsProps } from "../../types/item";
import { GET } from "../../services/axios.service";
import {
  JobworksPartiesItemProps,
  JobworksPartiesProps,
} from "../../types/jobworksParties";
import { RootState } from "../../app/store";

export interface PartiesItemState {
  isPartiesItemModalOpen: boolean;
  party: JobworksPartiesProps | null;
  partiesItem: JobworksPartiesItemProps[];
  items: ItemsProps[];
  loading: boolean;
  error: string | null;
}

const initialState: PartiesItemState = {
  isPartiesItemModalOpen: false,
  party: null,
  partiesItem: [],
  items: [],
  loading: false,
  error: null,
};

export const fetchItemsList = createAsyncThunk(
  "fetchItemsListForJobworksPartiesItem",
  async () => {
    let response: any;
    await GET(`/v1/admin/items`, { all: true })
      .then((res: any) => {
        response = res;
      })
      .catch((err) => {
        response = err;
      });
    return response;
  }
);

export const fetchJobworksPartiesItemListData = createAsyncThunk(
  "fetchJobworksPartiesItemListData",
  async (id: number) => {
    let response: any;
    await GET(`/v1/admin/jobworks-parties/${id}/items`, {})
      .then((res: any) => {
        response = res;
      })
      .catch((err) => {
        response = err;
      });
    return response;
  }
);

export const jobworksPartiesItemSlice = createSlice({
  name: "jobworksPartiesItem",
  initialState,
  reducers: {
    togglePartiesItemModal: (state, action: PayloadAction<boolean>) => {
      state.isPartiesItemModalOpen = action.payload;
      if (!action.payload) {
        state.party = null;
        state.partiesItem = [];
        state.items = [];
      }
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchItemsList.pending, (state, action: any) => {
      state.items = [];
    });
    builder.addCase(fetchItemsList.fulfilled, (state, action: any) => {
      if (action.payload.data.status === "success") {
        state.items = action.payload.data.data.records;
      } else {
        state.items = [];
      }
    });
    builder.addCase(fetchItemsList.rejected, (state, action: any) => {
      state.items = [];
    });

    builder.addCase(
      fetchJobworksPartiesItemListData.pending,
      (state, action: any) => {
        state.party = null;
        state.partiesItem = [];
        state.loading = true;
        state.error = null;
      }
    );
    builder.addCase(
      fetchJobworksPartiesItemListData.fulfilled,
      (state, action: any) => {
        state.loading = false;
        if (action.payload.data.status === "success") {
          state.party = action.payload.data.data.party_info;
          state.partiesItem = action.payload.data.data.party_items;
          state.error = null;
        } else {
          state.party = null;
          state.partiesItem = [];
          state.error =
            action?.payload?.data?.message ||
            "કંઈક ખોટું ગયું, કૃપા કરીને ફરીથી પ્રયત્ન કરો.";
        }
      }
    );
    builder.addCase(
      fetchJobworksPartiesItemListData.rejected,
      (state, action: any) => {
        state.party = null;
        state.partiesItem = [];
        state.loading = false;
        state.error =
          action?.payload?.data?.message ||
          "કંઈક ખોટું ગયું, કૃપા કરીને ફરીથી પ્રયત્ન કરો.";
      }
    );
  },
});

export const { togglePartiesItemModal } = jobworksPartiesItemSlice.actions;

export const getParty = (state: RootState) => state.jobworksPartiesItem.party;

export const getItems = (state: RootState) => state.jobworksPartiesItem.items;

export const getPartiesItem = (state: RootState) =>
  state.jobworksPartiesItem.partiesItem;

export const getIsPartiesItemModalOpen = (state: RootState) =>
  state.jobworksPartiesItem.isPartiesItemModalOpen;

export default jobworksPartiesItemSlice.reducer;
